

require("./application");



import 'bootstrap/dist/js/bootstrap';

import "../stylesheets/frontend.scss";
import 'bootstrap-icons/font/bootstrap-icons.css';




/* FRONT ASSETS */

//import "../vendor/frontend/assets/vendor/cookieconsent/dist/cookieconsent";






/* FOR TEKUP TEMPLATE */


  import "../vendor/frontend/assets/js/menu/menu.js";
  import "../vendor/frontend/assets/js/jquery.magnific-popup.min.js";
  import "../vendor/frontend/assets/js/slick.js";
  import "../vendor/frontend/assets/js/countdown.js";
  
  import WOW from  "../vendor/frontend/assets/js/wow.min.js";
  window.WOW = WOW;

  import AOS from "../vendor/frontend/assets/js/aos.js";
  window.AOS = AOS;

  import Swiper from  "../vendor/frontend/assets/vendor/swiper/swiper-bundle.min.js";
  window.Swiper = Swiper;

   //import "../vendor/frontend/assets/vendor/isotope-layout/isotope.pkgd.min.js";

  

  import "../vendor/frontend/assets/js/skill-bar.js";
  import "../vendor/frontend/assets/js/slick-animation.min.js";
  import "../vendor/frontend/assets/js/faq.js";



  //require("../vendor/frontend/assets/vendor/cookieconsent/dist/cookieconsent.umd.js");
  // Exposer la variable globale dans Webpack
//const cc = window.initCookieConsent();

require('./frontend/cc');

document.addEventListener('DOMContentLoaded', function () {
  window.initCookieConsentWrapper();
});
 
  //import "../vendor/frontend/assets/js/isotope.pkgd.min.js";
  
  import Isotope from  "../vendor/frontend/assets/js/isotope.pkgd.min.js";
  window.Isotope = Isotope;

  //import "../vendor/frontend/tekup/assets/js/tabs-slider.js";
  
  import "../vendor/frontend/assets/js/product-increment.js";


  import "../vendor/frontend/assets/js/app.js";

  /* END TEKUP */

require("./frontend/social-share-button.init");

require("./frontend/swiper.init");
//require("./frontend/cookieconsent.init");
//require("./frontend/cookieconsent-config");







/* END */